import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Button } from "components/common";
import { getPaymentRequest, refreshPaymentRequestBankStatus } from "redux/erp/paymentRequestSlice";

/**
 * Asks HSBC about a payment whose outcome is unclear (HSBC answered 5xx with a reference —
 * PRQ-202600013, 2026-10-23), right in the red box. A definite answer settles it: HSBC
 * has it (processing / paid), or HSBC rejected it (sending again is then allowed).
 */
const CheckHsbcStatusButton = ({ paymentRequest: pr }) => {
  const dispatch = useDispatch();
  const [busy, setBusy] = useState(false);
  const busyRef = useRef(false);
  if (!pr?.permissions?.allow_check_bank_status) return null;

  const check = async () => {
    if (busyRef.current) return;
    busyRef.current = true;
    setBusy(true);
    try {
      const res = await dispatch(refreshPaymentRequestBankStatus(pr.id)).unwrap();
      if (res?.warning) toast.warning(res.message, { autoClose: 12000 });
      else toast.success(res?.message || "HSBC status checked.");
    } catch (e) {
      toast.error(e?.error || e?.message || "Could not ask HSBC for the status.");
    } finally {
      busyRef.current = false;
      setBusy(false);
      dispatch(getPaymentRequest(pr.id));
    }
  };

  return (
    <Button size="sm" className="tw-mt-2" loading={busy} aria-busy={busy} onClick={check}>
      {!busy && <i className="bi bi-arrow-clockwise" aria-hidden="true" />} {busy ? "Checking…" : "Check HSBC status"}
    </Button>
  );
};

CheckHsbcStatusButton.propTypes = { paymentRequest: PropTypes.object };

export default CheckHsbcStatusButton;
